import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  Inject
} from "@angular/core";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { UnitOfWorkService } from "src/app/services/api/uow/unit-of-work.service";
import { JqHelper } from "src/app/common/jq-helper";
import { G_SaleMasterViewModel } from "src/app/viewmodels/g-sale/G_SaleMasterViewModel";
import { ItemViewModel, ItemViewModel1 } from "src/app/viewmodels/ItemViewModel";
import { GItemDefiningViewModel } from "src/app/viewmodels/g-item/GItemDefiningViewModel";
import { GVechileViewModel } from "src/app/viewmodels/g-vehicle/GVechileViewModel";
import { G_PurchaseMasterViewModel } from "src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel";
import { PurchaseDetailViewModel } from "src/app/viewmodels/g-purchase/PurchaseDetailViewModel";
import { GPackagesViewModel } from "src/app/viewmodels/g-packages/GPackagesViewModel";
import { GPackageItemViewModel } from "src/app/viewmodels/g-packages/GPackageItemViewModel";
import { GPackagesModelViewModel } from "src/app/viewmodels/g-packages/GPackagesModelViewModel";
import { ActivatedRoute, Router } from "@angular/router";
import { G_ComplainsSuggestionsViewModel } from "src/app/viewmodels/g-settings/G_ComplainsSuggestionsViewModel";
import { AccountDefiningModel, DefineAccountviewModel } from "src/app/viewmodels/g-customer/DefineAccountviewModel";
import { G_TagsViewModel } from "src/app/viewmodels/g-settings/G_TagsViewModel";
import { SaleDetailViewModel } from "src/app/viewmodels/g-sale/SaleDetailViewModel";
import { G_PackagesTypeViewModel } from "src/app/viewmodels/g-packages/G_PackagesTypeViewModel";
import { HttpClient } from "@angular/common/http";
import { DOCUMENT } from "@angular/common";
import Swal from "sweetalert2/dist/sweetalert2.all.js";
import { timer } from "rxjs";
import { E_G_EPSStatusType } from "src/app/viewmodels/g-purchase/E_G_EPSStatusType";
import { NgxSpinnerService } from "ngx-spinner";
import { LocalStorageService } from "src/app/services/common/local-storage.service";
import { ComplainsSuggestionsModel, GPackagesModel, SaleDetailModel, SaveSaleMasterRequest, TagsModel } from "src/app/viewmodels/g-purchase/GPurchaseViewModel";
import { GPackageItemModel, SaveGVehicleRequest, SaveItemRequest } from "src/app/viewmodels/g-settings/GSettingViewModel";

@Component({
  selector: "app-work-in-progess-form",
  templateUrl: "./work-in-progess-form.component.html",
  styleUrls: ["./work-in-progess-form.component.scss"],
})
export class WorkInProgessFormComponent implements OnInit {
  disabled = true;

  public vmListItems: any = [];
  @Input() public vmC: ComplainsSuggestionsModel;
  @Input() public vmD: AccountDefiningModel;
  @Input() public vmP: GPackagesModel;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  public component_Title = "Sale";
  public vehicleDetail: any = [];
  public complaintsType: any = [];
  public ccomplaintsType: "complaintsType";
  public packageTypes: any = [];
  public cvehicleDetail = "vehicleDetail";
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public saleDetailVM: any = [];
  public services: any = [];
  public selectedServices: any = [];
  public cpackageTypes = "packageTypes";
  public items: any = [];
  public brands: any = [];
  public selectedBrands: any = [];
  public models: any = [];
  public selectedModels: any = [];
  public citems: any = "items";
  public cbrands: any = "brands";
  public cmodels: any = "models";
  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectedPacakgeTypes: any = [];
  public tags: any = [];
  public selectedTagList: any;
  public selectedsaleDetail: any[];
  public saleDetail: any[];
  public selectedServicesList: any = [];
  public selectedSaprePartsList: any = [];
  public itemTypes = [];
  public csaleDetail: any[];
  public DisableSave: boolean = false;
  public userAssignedWareHouses: Array<any> = [];
  public userWareHouses: Array<any> = [];
  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 6,
    allowSearchFilter: true,
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 6,
    allowSearchFilter: true,
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 6,
    allowSearchFilter: true,
  };
  public PackageSelectionDropdown: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1,
  };

  public ssItemVm = new GItemDefiningViewModel();
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "registrationNumber",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 6,
    allowSearchFilter: true,
  };
  modalRef: BsModalRef;
  public calingUrl: string;
  public urlId: string;
  findingsType: any;
  submitted: boolean;
  selectedTagsList: any;
  selectedComplaint: any;
  selectedFindings: any;
  public SelectedItemServices: any = [];
  public client: any;
  public user: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    public _router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    debugger;
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.getSpareParts();
    this.getSparePartsAndServices();
    this.getPackageTypes();
    this.getTags();
    if (this.modal_title == undefined) {
      this.modal_title = "Work in Progress";
    }
    this.vm = new SaveSaleMasterRequest();
    this.saleDetailVM = new SaleDetailModel();
    //console.log(this.vm);
    this.route.queryParams.subscribe((params) => {
      this.urlId = params["id"];
    });
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe(
      (res: any) => {
        debugger
        this.spinner.hide();
        let selectedWarehouse: any = [];
        console.log(res);
        this.vm = res;
        debugger
        this.vm.gWareHouse = new ItemViewModel1(res.gWareHouse.id, res.gWareHouse.name);
        if (this.vm.gWareHouse.id == null) {
          this.DisableSave = true;
        }
        //   this.vm.Fk_G_WareHouse_Id = this.userAssignedWareHouses.find(
        //     (w: any) => w.FK_WareHouse_Id.Id === res.Fk_G_WareHouse_Id.Id
        //  ).FK_WareHouse_Id;  // Find and assign the matching FK_WareHouse_Id object

        if (this.vm.gWareHouse !== undefined) {
          selectedWarehouse.push({ warehouse: this.vm.gWareHouse });
          //this.userAssignedWareHouses = selectedWarehouse;
        }
        // this._jq.showSpinner();
        //this.spinner.hide();
        let selectedServicesList: any = [];
        let selectedSaprePartsList: any = [];
        this.vm.saleDetails.forEach((x) => {
          if (x.itemType.name === "Spare-Parts") {
            let ab = new GPackageItemModel();
            ab.quantity = x.quantity;
            ab.ssItemDefining = new ItemViewModel1(
              x.item.id,
              x.item.name
            );
            ab.discountPercentage = x.discount;
            ab.salePrice = 0;
            ab.salePrice = x.salePrice;
            ab.amount = 0;
            ab.amount = x.totalAmount;
            ab.discountAmount = 0;
            ab.discountAmount = x.discountAmount;
            this.vmP.spareParts.push(ab);
            let partssSelected = new SaveItemRequest();
            partssSelected.id = x.item.id;
            partssSelected.name = x.item.name;
            selectedSaprePartsList.push(partssSelected);
            //this.InventoryCheck(x.FK_G_Item_Id.Id);
            this.discountChange(ab, 0);
          }

          if (x.itemType.name === "Services") {
            let ab = new GPackageItemModel();
            ab.quantity = x.quantity;
            ab.ssItemDefining = new ItemViewModel1(
              x.item.id,
              x.item.name
            );
            ab.discountPercentage = x.discount;
            ab.salePrice = 0;
            ab.salePrice = x.salePrice;
            ab.amount = 0;
            ab.amount = x.totalAmount;
            ab.discountAmount = 0;
            ab.discountAmount = x.discountAmount;
            this.vmP.services.push(ab);
            let serviceslect = new SaveItemRequest();
            serviceslect.id = x.item.id;
            serviceslect.name = x.item.name;
            selectedServicesList.push(serviceslect);
            this.discountChange(ab, 0);
          }
        });
        this.selectedSpareParts = selectedSaprePartsList;
        this.SelectedItemServices = selectedServicesList;
        console.log(res);
      },
      (err) => {
        this.spinner.hide();
        console.log(err);
        // setTimeout(() => {
        //   /** spinner ends after 5 seconds */
        //   this.spinner.hide();
        // }, 5000);
      }
    );
    if (this.vmD == undefined) {
      this.vmD = new AccountDefiningModel();
      this._uow.gSettingService.LoadAccountFormAsync().subscribe(
        (res: any) => {
          this.vmD.accCode = res.code;
        },
        (err) => console.log(err)
      );
    }
    if (this.vmP == undefined) {
      this.vmP = new GPackagesModel();
      this.vmP.services = [];
      this.vmP.spareParts = [];
      this.selectedPacakgeTypes = [];
    } else {
      if (this.vmP.services !== undefined && this.vmP.services.length > 0) {
        this.vmP.services.forEach((x) => {
          this.selectedServices.push(
            new ItemViewModel1(
              x.ssItemDefining.id,
              x.ssItemDefining.name
            )
          );
        });
      }
      if (this.vmP.spareParts !== undefined && this.vmP.spareParts.length > 0) {
        this.vmP.spareParts.forEach((x) => {
          this.selectedSpareParts.push(
            new ItemViewModel1(
              x.ssItemDefining.id,
              x.ssItemDefining.name
            )
          );
        });
      }
      if (
        this.vmP.gPackagesModel !== undefined &&
        this.vmP.gPackagesModel.length > 0
      ) {
        this.vmP.gPackagesModel.forEach((x) => {
          this.selectedPacakgeTypes.push(
            new ItemViewModel1(x.pacakage.id, x.pacakage.name)
          );
        });
      }
    }
    if (
      this.vm.salesTagsList !== undefined &&
      this.vm.salesTagsList.length > 0
    ) {
      this.vm.salesTagsList.forEach((x) => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
      this.vm.saleDetails.forEach((x) => {
        this.saleDetail.push(
          new ItemViewModel1(x.item.id, x.item.name)
        );
      });
    }

    // this.itemVm = new GVechileViewModel();
    // let id = this.route.snapshot.params['id'];
    // this._uow.vehicleService.GetById(id).subscribe((res: any)=>{
    //   this.itemVm = res;
    //   this.itemVm.FK_G_Model = new ItemViewModel(res.FK_G_Model.Id,res.FK_G_Model.Name);
    //   this.itemVm.Fk_G_Customer_Id = new ItemViewModel(res.Fk_G_Customer_Id.Id,res.Fk_G_Customer_Id.Name);
    //   this.itemVm.FK_TagId = new ItemViewModel(res.FK_TagId.Id, res.FK_TagId.Name);
    //  // this.vm.FK_ClientId = new ItemViewModel(res.FK_ClientId.Id, res.FK_ClientId.Name);
    //   console.log(res);
    // },(err)=>{
    //   console.log(err);
    // })
    // if (this.itemVm.FK_Tag_List !== undefined && this.itemVm.FK_Tag_List.length > 0) {
    //   this.itemVm.FK_Tag_List.forEach(x => {
    //     this.selectedTagList.push(new ItemViewModel(x.Id, x.Name));
    //   });
    // }
    // if (this.vm == undefined) {
    //   this.vm = new G_SaleMasterViewModel();
    //   this.saleDetail = [];
    //   this.selectedsaleDetail = [];
    // } else {

    // }
    this.getUserAssignedWareHouse().then((res) => {
      this.getSpareParts(res[0].res[0].FK_WareHouse_Id.Id);
    });
    this.DisableSave = true;
    // setTimeout(() => {
    //<<<---    using ()=> syntax
    this.InventoryCheckAll();
    // }, 1000);
  }
  getUserAssignedWareHouse() {
    debugger
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        console.log("ware house", res);
        debugger
        this.userAssignedWareHouses = res.result;
        //   this.userAssignedWareHouses = res.map((w: any) => ({
        //     FK_WareHouse_Id: w.FK_WareHouse_Id
        // }));
        this.userWareHouses = res;
        resolve(res);
      });
    });
  }
  getSpareParts(id?) {
    let selectedSpare: any = [];
    this._jq.showSpinner(true);
    this._uow.gSettingService
      .GetItemsDropDownByWarehouseIdAsync(id)
      .subscribe(
        (res: any) => {
          this.spareParts = res.result;
          this.InventoryCheckAll();
          console.log(res);
          if (this.selectedSpareParts.length > 0) {
            console.log(this.selectedSpareParts);
            this.selectedSpareParts.forEach((x) => {
              console.log(this.vmP.spareParts);
              let selected = this.vmP.spareParts.find(
                (z) => z.ssItemDefining.id === x.id
              );
              console.log("selcetd part", selected);
              let md = new ItemViewModel1();
              (md.id = selected.ssItemDefining.id),
                (md.name = selected.ssItemDefining.name);
              selectedSpare.push(md);
              this.selectedSpareParts = selectedSpare;
            });
          }
          this._jq.showSpinner();
        },
        (err) => {
          this._uow.logger.log(err);
          this.spareParts = [];
          this._jq.showSpinner();
        }
      );
  }
  getSparePartsAndServices() {
    //'Spare-Parts'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Spare-Parts").subscribe(
      (res: any) => {
        // this._uow.logger.log(res);
        this.spareParts = res.result;
        // this._uow.logger.log(`spare parts ${JSON.stringify(res)}`);
      },
      (err) => {
        this._uow.logger.log(err);
        this.spareParts = [];
      }
    );
    // 'Services'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Services").subscribe(
      (res: any) => {
        this.services = res.result;
        // this._uow.logger.log(`services ${res}`);
      },
      (err) => {
        this._uow.logger.log(err);
        this.services = [];
        this._jq.showSpinner();
      }
    );
  }
  getPackageTypes() {
    this._uow.gSettingService.GetPackageTypesAsync().subscribe(
      (res: any) => {
        this.packageTypes = res.result;
        this._uow.logger.log(res);
      },
      (error) => {
        this._uow.logger.log(error);
        this.packageTypes = [];
        this._jq.showSpinner();
      }
    );
  }
  getTags() {
    this._uow.gSettingService.GetTagsAsync().subscribe(
      (res: any) => {
        this.tags = res.result;
      },
      (err) => {
        console.log(err);
        this._jq.showSpinner();
      }
    );
  }

onSelectWareHouse() {
    this.getSpareParts(this.vm.gWareHouse.id);
  }
onSelectSparePart(e) {
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    this._uow.logger.log(e);

    let item = this.spareParts.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = 0;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.vm.customerDiscount > 0) {
        a.discountPercentage = this.vm.customerDiscount;
      }
      this.vmP.spareParts.push(a);
      this.discountChange(this.vmP.spareParts[this.vmP.spareParts.indexOf(a)]);
    }
    this.InventoryCheck(e.Id);
    this.calculateTotals();
  }

  onDeSelectSparePart(e) {
    this.selectedSpareParts = [];
    let selectedSaprePartsList: any = [];
    this.userAssignedWareHouses = this.userWareHouses;
    let i = this.vmP.spareParts.find(
      (x) => x.ssItemDefining.id === e.id
    );
    if (i !== undefined) {
      this.vmP.spareParts.splice(this.vmP.spareParts.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
    this.InventoryCheckAll();
  }
 //service
  onSelectService(e) {
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    this._uow.logger.log(e);
    let item = this.services.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      //i.AvalibelQuantity = item.CurrentStock;
      i.itemCode = item.code;
      i.discountedRate = 0;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      if (this.vm.customerDiscount > 0) {
        a.discountPercentage = this.vm.customerDiscount;
      }
      this.vmP.services.push(a);
      this.discountChange(this.vmP.spareParts[this.vmP.spareParts.indexOf(a)]);
    }

    this.calculateTotals();
  }

  onDeSelectService(e) {
    this.selectedServices = [];
    let selectedServicesList: any = [];
    let i = this.vmP.services.find((x) => x.ssItemDefining.id === e.id);
    if (i !== undefined) {
      this.vmP.services.splice(this.vmP.services.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
  }
 RemoveSparePart(e) {
    this.selectedSpareParts = [];
    let selectedSaprePartsList: any = [];
    let i = this.vmP.spareParts.find(
      (x) => x.ssItemDefining.id === e.ssItemDefining.id
    );
    if (i !== undefined) {
      this.vmP.spareParts.splice(this.vmP.spareParts.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.vmP.spareParts.forEach((x) => {
      let partssSelected = new SaveItemRequest();
      partssSelected.id = x.ssItemDefining.id;
      partssSelected.name = x.ssItemDefining.name;
      selectedSaprePartsList.push(partssSelected);
    });
    this.selectedSpareParts = selectedSaprePartsList;
    this.calculateTotals();
    this.InventoryCheckAll();
  }

 RemoveService(e) {
    this.SelectedItemServices = [];
    let selectedServicesList: any = [];
    let i = this.vmP.services.find(
      (x) => x.ssItemDefining.id === e.ssItemDefining.id
    );
    if (i !== undefined) {
      this.vmP.services.splice(this.vmP.services.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.vmP.services.forEach((x) => {
      let partssSelected = new SaveItemRequest();
      partssSelected.id = x.ssItemDefining.id;
      partssSelected.name = x.ssItemDefining.name;
      selectedServicesList.push(partssSelected);
    });
    this.SelectedItemServices = selectedServicesList;
    this.calculateTotals();
  }

  saveOrUpdate() {
    // this._jq.showSpinner(true);

    this.spinner.show();
    let obj = this.itemVm;

    this.vm.statusType = new ItemViewModel1(6, "SaleWIP");
    this.vm.invAmount = this.vmP.packageAmount;
    this.vm.paidAmount = this.vm.invAmount;
    console.log(this.vm);
    this._uow.gSaleService
      .SaveGSaleAsync(this.vm)
      .toPromise()
      .then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        // setTimeout(() => {
        //   /** spinner ends after 5 seconds */
        //   this.spinner.hide();
        // }, 3000);
        this.spinner.hide();
        Swal.fire("Saved!", "Repair Order Updated!", "success");
        //this.bsmRef.hide();
        //alert("Repair Order Saved Successfully");
        //this._router.navigate(['/repair-order-list'])

        //this._document.defaultView.location.reload();
        this.bsmRef.hide();
        // this._jq.showSpinner();
      })
      .catch((error) => {
        this.spinner.hide();
        Swal.fire("Error!", "Repair Order Not Updated!", "warning");
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        // setTimeout(() => {
        //   /** spinner ends after 5 seconds */
        //   this.spinner.hide();
        // }, 3000);
      });
  }

  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }

  quantityChange(e, i?) {
    //e.DiscountAmount = 0;
    e.amount = e.quantity * e.discountAmount;
    let saledetail = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledetail != undefined) {
      saledetail.quantity = e.quantity;
      saledetail.totalAmount = e.amount;
    }
    //  if (e.DescountPercentage > 0) {
    //    e.Amount = (e.Amount - ((e.DescountPercentage / 100) * e.Amount));
    //  }
    this.calculateTotals();
    this.InventoryCheckAll();
    //this.InventoryCheck(e.Fk_G_SSItemDefining_Id.Id);
  }

  discountChange(e, i?) {
    let discountAMmount = (e.discountPercentage * e.salePrice) / 100;
    e.discountAmmount = discountAMmount;
    e.discountAmount = e.salePrice - e.discountAmmount;
    e.amount = e.discountAmount * e.quantity;

    let saledtl = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledtl != undefined) {
      saledtl.discountAmount = e.discountAmmount;
      saledtl.discount = e.discountPercentage;
      saledtl.discountedRate = e.discountAmount;
      saledtl.totalAmount = e.amount;
    }
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount <= 0){
    //   let discountAMmount = ((e.DescountPercentage / 100) * e.Amount);
    //   e.Amount = (e.Amount - discountAMmount);
    //   this.calculateTotals();
    // }
    this.calculateTotals();
  }

  amountChange(e, i?) {
    e.discountPercentage = (e.discountAmmount * 100) / e.salePrice;
    this.discountChange(e, i);
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount < 0){
    //   let discountAMmount = (e.Amount-e.DescountAmmount);
    //   e.Amount = (discountAMmount);

    // }
    this.calculateTotals();
  }


  // Tags
  // onSelectTags(e) {
  //   if (
  //     this.vm.salesTagsList == undefined ||
  //     this.vm.salesTagsList.length == 0
  //   ) {
  //     this.vm.salesTagsList = [];
  //   }

  //   this._uow.logger.log(e);
  //   let item = this.tags.find((x) => x.id === e.id);
  //   if (item !== undefined) {
  //     let i = new TagsModel();
  //     i.id = item.id;
  //     i.name = item.name;
  //     i.fkTagId = item.id;
  //     this.vm.salesTagsList.push(i);
  //     // let a = new G_SaleMasterViewModel();
  //     // a.Id = item.Id;
  //     // a.Name = item.Name;
  //     // this.vm.SalesTags.push(i);
  //   }
  // }

  // onDeSelectTags(e) {
  //   let i = this.vm.salesTagsList.find((x) => x.fkTagId === e.id);
  //   if (i !== undefined) {
  //     this.vm.salesTagsList.splice(this.vm.salesTagsList.indexOf(i), 1);
  //   }
  // }

  InventoryCheck(e) {
    let SparepartsEvent = this.spareParts.find((y) => y.id === e);
    if (SparepartsEvent != undefined && SparepartsEvent != null) {
      let AlreadySelectedParts = this.vmP.spareParts.find(
        (y) => y.ssItemDefining.id === e
      );
      if (AlreadySelectedParts != undefined && AlreadySelectedParts != null) {
        let AlreadyPartsIndex = this.vmP.spareParts.indexOf(
          AlreadySelectedParts
        );
        if (AlreadySelectedParts.quantity > SparepartsEvent.currentStock) {
          if (AlreadyPartsIndex != undefined) {
            this.vmP.spareParts[AlreadyPartsIndex].isInventry = false;
          }
          this.DisableSave = true;
        } else {
          if (AlreadyPartsIndex != undefined) {
            this.vmP.spareParts[AlreadyPartsIndex].isInventry = true;
          }
          AlreadySelectedParts.isInventry = true;
          this.DisableSave = false;
        }
      }
    }
  }

  InventoryCheckAll() {
    debugger;
    if (this.vmP.spareParts != undefined && this.vmP.spareParts.length > 0) {
      this.vmP.spareParts.forEach((x) => {
        let SparepartsEvent = this.spareParts.find(
          (y) => y.Id === x.ssItemDefining.id
        );
        if (SparepartsEvent != undefined && SparepartsEvent != null) {
          if (x.quantity > SparepartsEvent.currentStock) {
            x.isInventry = false;
            this.DisableSave = true;
          } else {
            x.isInventry = true;
            this.DisableSave = false;
          }
        }
      });
    } else {
      this.DisableSave = false;
    }
  }

  calculateTotals() {
    this.vmP.discountAmount = 0;
    this.vmP.serviceAmount = 0;
    this.vmP.services.forEach((x) => {
      this.vmP.serviceAmount += x.amount;
      if (x.discountAmmount > 0) {
        this.vmP.discountAmount += x.discountAmmount * x.quantity;
      }
    });

    this.vmP.partsAmount = 0;
    this.vmP.spareParts.forEach((x) => {
      this.vmP.partsAmount += x.amount;
      if (x.discountAmmount > 0) {
        this.vmP.discountAmount += x.discountAmmount * x.quantity;
      }
    });

    // this.vmP.SpareParts.forEach(x => {
    //  this.vmP.PartsAmount += x.Amount;
    //   if (x.DescountAmmount > 0) {
    //     //this.vmP.DiscountAmount += (x.Amount - x.DescountAmmount);
    //     this.vmP.DiscountAmount = x.Amount-x.DescountAmmount;
    //     this.vmP.DiscountAmount = x.DescountAmmount;
    //   }
    // });

    // this.vmP.Services.forEach(x => {
    //   //this.vmP.ServiceAmount += x.Amount;
    //   if (x.DescountAmmount > 0) {
    //     this.vmP.DiscountAmount = x.Amount-x.DescountAmmount;
    //   }
    // });

    this.vmP.packageAmount = this.vmP.partsAmount + this.vmP.serviceAmount;
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }

  openModalLg(template: TemplateRef<any>, itemtype?) {
    this.ssItemVm = new GItemDefiningViewModel();
    if (itemtype == 1) {
      let i = this.itemTypes.find((x) => x.Name == "Spare-Parts");
      console.log(i);
      this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
    }
    if (itemtype == 2) {
      let i = this.itemTypes.find((x) => x.Name == "Services");
      this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
    }
    this.openModal(template);
    this.modalRef.setClass("modal-lg");
  }

  // getRegNo() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe(
  //     (res: any) => {
  //       console.log(res);
  //       this._jq.showSpinner();
  //       this.vm.Fk_G_Vechile_Id = res.code;
  //     },
  //     (error) => {
  //       console.log(error);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  //'Spare-Parts'


  // getRequisitions() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe(
  //     (res: any) => {
  //       console.log(res.DtlList);
  //       this.vehicleDetail = res.RegistraionNumber;
  //       this._jq.showSpinner();
  //     },
  //     (error) => {
  //       console.log(error);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  // getVehicleDetail() {
  //   //'Spare-Parts'
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetById("Vehicle-Detail").subscribe(
  //     (res: any) => {
  //       this.vehicleDetail = res;
  //       console.log(res);
  //       this._jq.showSpinner();
  //     },
  //     (err) => {
  //       this._uow.logger.log(err);
  //       this.vehicleDetail = [];
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  openModal1(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    //  if (lvl == 2) {
    //    this.modalRefLv2 = this._modalService.show(template);
    //  }
  }

  // getSortIndexList(sIndex) {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetPagedResult(0, 50, sIndex).subscribe(
  //     (res: any) => {
  //       this.vmListItems = res.DtlList;
  //       console.log(res);

  //       this._jq.showSpinner();
  //     },
  //     (err) => {
  //       console.log(err);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.vm = new SaveSaleMasterRequest();
    }
  }


  // openDeleteModel(template: TemplateRef<any>, model) {
  //   this.openModal(template, 1);
  //   if (model !== undefined) {
  //     this.itemVm = model;
  //   }
  // }

  // conformDelete() {
  //   this._uow.gSaleService.Delete(this.vm).subscribe(
  //     (res: any) => {
  //       this.getList();
  //       //this.modalRefLv1.hide();
  //     },
  //     (err) => {
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  // getList() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe(
  //     (res: any) => {
  //       this.vmListItems = res.DtlList;
  //       console.log(res);
  //       this._jq.showSpinner();
  //     },
  //     (err) => {
  //       console.log(err);
  //       this._jq.showSpinner();
  //     }
  //   );
  // }

  // input changes
  // quantityOrPriceChanged(m) {
  //   m.totalAmount = m.quantity * m.purchasePrice;
  //   this.updateTotals();
  // }

  // public TotalPayable = 0;
  // public TotalVat = 0;
  // public TotalPayableAfterVat = 0;
  // updateTotals() {
  //   this.TotalPayableAfterVat = 0;
  //   this.TotalVat = 0;
  //   this.TotalPayable = 0;
  //   if (
  //     this.itemVm.SaleDetails !== undefined &&
  //     this.itemVm.SaleDetails.length > 0
  //   ) {
  //     this.itemVm.SaleDetails.forEach((x) => {
  //       this.TotalPayable += x.TotalAmount;
  //       this.TotalVat += x.VatAmount;
  //       this.TotalPayableAfterVat += x.TotalAmount + x.VatAmount;
  //     });
  //   }
  // }
}
